<template>
  <!-- 搜索引擎 -->
  <div id="searchEngineD" class="listStyle">
    <div id="goToHere2"></div>
    <!-- 点击弹出搜索弹框 -->
    <!-- <div @click="showSearchPopup = true" class="openPopup">
      <van-sticky :offset-top="80">
        <van-cell title="打开搜索引擎" is-link />
      </van-sticky>
    </div> -->
    <searchEnginePop
      ref="searchEnginePop"
      :option1="option1"
      :option2="option2"
      :option3="option3"
      :option4="option4"
      :option11="option11"
      :option12="option12"
      :option13="option13"
      :disabled1="disabled1"
      :disabled2="disabled2"
      :disabled3="disabled3"
      @changeSearch1="changeSearch1"
      @changeSearch5="changeSearch5"
      @changeSearch6="changeSearch6"
      @changeSearch7="changeSearch7"
      @changeSearch8="changeSearch8"
      @changeValue1="changeValue1"
      @changeValue2="changeValue2"
      @changeValue3="changeValue3"
      @changeValue4="changeValue4"
      @changeValue11="changeValue11"
      @changeValue12="changeValue12"
      @changeValue13="changeValue13"
      @changeRadio="changeRadio"
      @searchDatas="searchDatas"
    ></searchEnginePop>
    <div class="top">
      <!-- 法规分类 -->
      <classification-rules
        ref="classification"
        @showGetData="showGetData"
        @changeTagid="changeTagid"
        :classifytag="data"
        :stime="stime"
        :etime="etime"
        :searchText="searchText"
      ></classification-rules>
      <!-- 法规层级 -->
      <regulations-hierarchy
        v-if="flag"
        ref="regulations"
        @getSearchLists="getSearchLists"
      ></regulations-hierarchy>
      <!-- 搜索框 -->
      <SearchBox
        v-show="flag"
        ref="searchBox"
        @searchKeyWord="searchKeyWord"
        @selectTime="selectTime"
        @clearTime="clearTime"
      ></SearchBox>
      <!-- 搜索弹框 -->
      <van-popup
        v-model="showSearchPopup"
        closeable
        close-icon="close"
        position="top"
        :style="{ height: '100%' }"
      >
        <div class="selectNavS">
          <van-divider
            :style="{
              color: '#1989fa',
              borderColor: '#1989fa',
              fontSize: '17px',
              marginTop: '20px',
            }"
          >
            搜索引擎
          </van-divider>
          <van-collapse v-model="activeNames" accordion>
            <van-collapse-item title="综合检索" name="1">
              <div class="searchItem">
                <div class="name">查询内容</div>
                <div class="content">
                  <van-field
                    v-model="search1"
                    clearable
                    input-align="center"
                    placeholder="请输入查询内容"
                    @input="changeSearch1"
                  />
                </div>
              </div>
              <div class="searchItem">
                <div class="name">文件效力</div>
                <div class="content">
                  <van-dropdown-menu>
                    <van-dropdown-item
                      v-model="value1"
                      :options="option1"
                      @change="changeValue1"
                    />
                  </van-dropdown-menu>
                </div>
              </div>
              <div class="btn" @click="searchDatas(1)">
                <van-button
                  block
                  icon="search"
                  style="border-radius: 30px"
                  type="info"
                  >查询</van-button
                >
              </div>
            </van-collapse-item>
            <van-collapse-item title="行业检索" name="2">
              <div class="searchItem">
                <div class="name">行业</div>
                <div class="content">
                  <van-dropdown-menu>
                    <van-dropdown-item
                      v-model="value2"
                      :options="option2"
                      @change="changeValue2"
                    />
                  </van-dropdown-menu>
                </div>
              </div>
              <div class="searchItem">
                <div class="name">文件效力</div>
                <div class="content">
                  <van-dropdown-menu>
                    <van-dropdown-item
                      v-model="value5"
                      :options="option1"
                      @change="changeSearch5"
                    />
                  </van-dropdown-menu>
                </div>
              </div>
              <div class="btn" @click="searchDatas(2)">
                <van-button
                  block
                  icon="search"
                  style="border-radius: 30px"
                  type="info"
                  >查询</van-button
                >
              </div>
            </van-collapse-item>
            <van-collapse-item title="税收优惠检索" name="3">
              <van-radio-group v-model="radio" @change="changeRadio">
                <van-cell-group>
                  <van-cell title="税收优惠项目" clickable @click="radio = '1'">
                    <template #right-icon>
                      <van-radio name="1" />
                    </template>
                  </van-cell>
                  <van-cell title="税收优惠行业" clickable @click="radio = '3'">
                    <template #right-icon>
                      <van-radio name="3" />
                    </template>
                  </van-cell>
                  <van-cell title="税收优惠税种" clickable @click="radio = '2'">
                    <template #right-icon>
                      <van-radio name="2" />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
              <div class="searchItem">
                <div class="name">优惠项目</div>
                <div class="content">
                  <van-dropdown-menu>
                    <van-dropdown-item
                      v-model="value11"
                      :disabled="disabled2"
                      :options="option11"
                      @change="changeValue11"
                    />
                  </van-dropdown-menu>
                </div>
              </div>
              <div class="searchItem">
                <div class="name">优惠行业</div>
                <div class="content">
                  <van-dropdown-menu>
                    <van-dropdown-item
                      v-model="value13"
                      :disabled="disabled3"
                      :options="option13"
                      @change="changeValue13"
                    />
                  </van-dropdown-menu>
                </div>
              </div>
              <div class="searchItem">
                <div class="name">优惠税种</div>
                <div class="content">
                  <van-dropdown-menu>
                    <van-dropdown-item
                      v-model="value12"
                      :disabled="disabled1"
                      :options="option12"
                      @change="changeValue12"
                    />
                  </van-dropdown-menu>
                </div>
              </div>

              <div class="searchItem">
                <div class="name">文件效力</div>
                <div class="content">
                  <van-dropdown-menu>
                    <van-dropdown-item
                      v-model="value6"
                      :options="option1"
                      @change="changeSearch6"
                    />
                  </van-dropdown-menu>
                </div>
              </div>
              <div class="btn" @click="searchDatas(3)">
                <van-button
                  block
                  icon="search"
                  style="border-radius: 30px"
                  type="info"
                  >查询</van-button
                >
              </div>
            </van-collapse-item>
            <van-collapse-item title="条约检索" name="4">
              <div class="searchItem">
                <div class="name">国家/地区</div>
                <div class="content">
                  <van-dropdown-menu>
                    <van-dropdown-item
                      v-model="value3"
                      :options="option3"
                      @change="changeValue3"
                    />
                  </van-dropdown-menu>
                </div>
              </div>
              <div class="searchItem">
                <div class="name">文件效力</div>
                <div class="content">
                  <van-dropdown-menu>
                    <van-dropdown-item
                      v-model="value7"
                      :options="option1"
                      @change="changeSearch7"
                    />
                  </van-dropdown-menu>
                </div>
              </div>
              <div class="btn" @click="searchDatas(4)">
                <van-button
                  block
                  icon="search"
                  style="border-radius: 30px"
                  type="info"
                  >查询</van-button
                >
              </div>
            </van-collapse-item>
            <van-collapse-item title="进出口税收检索" name="5">
              <div class="searchItem">
                <div class="name">类别</div>
                <div class="content">
                  <van-dropdown-menu>
                    <van-dropdown-item
                      v-model="value4"
                      :options="option4"
                      @change="changeValue4"
                    />
                  </van-dropdown-menu>
                </div>
              </div>
              <div class="searchItem">
                <div class="name">文件效力</div>
                <div class="content">
                  <van-dropdown-menu>
                    <van-dropdown-item
                      v-model="value8"
                      :options="option1"
                      @change="changeSearch8"
                    />
                  </van-dropdown-menu>
                </div>
              </div>
              <div class="btn" @click="searchDatas(5)">
                <van-button
                  block
                  icon="search"
                  style="border-radius: 30px"
                  type="info"
                  >查询</van-button
                >
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </van-popup>

      <!-- 提示语 -->
      <!-- <div
        v-show="
          lists.length == 0 &&
            industryLists.length == 0 &&
            lists4.length == 0 &&
            commonLists.length == 0
        "
      >
        <van-notice-bar wrapable :scrollable="false">
          <h4>特别提示</h4>
          <p>
            请及时关注微信公众号“众智云擎”，
            {{
              userId && !wxunionid
                ? "点击“云擎中心”按钮进入“变动提醒”绑定账号，"
                : ""
            }}
            即时获取云端文件效力变动信息。
          </p>
        </van-notice-bar>
        <p style="padding-top: 37px; text-align: center">
          <img :src="gzhewm" alt="" style="width: 146px" />
        </p>
      </div> -->
      <!-- 列表组件 -->
      <list-content
        ref="listCont"
        :lists="lists"
        :total="total"
        :lockLists="lists4"
        :doubleLists="doubleLists"
        :commonLists="commonLists"
        :industryLists="industryLists"
        @changeCommonFlag="changeCommonFlag"
        @changeIndustryFlag="changeIndustryFlag"
        :countries="countries"
      ></list-content>
      <!-- 一键上传 -->
      <upload-file ref="uploadFile"></upload-file>
    </div>
    <div style="height: 0.001rem"></div>
    <!-- 分页 -->
    <div v-if="lists.length > 0" class="pageBoxStyle">
      <Pagination
        :currentPage="currentPage"
        :total="total"
        :totalLists="totalLists"
        @prevPage="prevPage"
        @nextPage="nextPage"
        @jumpToPageSize="jumpToPageSize"
      ></Pagination>
    </div>
    <div v-if="lists4.length > 0" class="pageBoxStyle">
      <Pagination
        :currentPage="currentPage5"
        :total="total5"
        :totalLists="totalLists"
        @prevPage="prevPage5"
        @nextPage="nextPage5"
        @jumpToPageSize="jumpToPageSize5"
      ></Pagination>
    </div>
    <div v-if="commonFlag && commonLists.length > 0" class="pageBoxStyle">
      <Pagination
        :currentPage="currentCommonPage"
        :total="commonTotal5"
        :totalLists="commonTotal5Lists"
        @prevPage="prevPage5"
        @nextPage="nextPage5"
        @jumpToPageSize="jumpToPageSize5"
      ></Pagination>
    </div>
    <div v-if="industryFlag && industryLists.length > 0" class="pageBoxStyle">
      <Pagination
        :currentPage="currentIndustryPage"
        :total="industryTotal5"
        :totalLists="industryTotal5lists"
        @prevPage="prevPage5"
        @nextPage="nextPage5"
        @jumpToPageSize="jumpToPageSize5"
      ></Pagination>
    </div>

    <!-- 底部导航 -->
    <tabbar
      ref="tabbar"
      @alertBars="alertBars"
      @alertCengji="alertCengji"
      @updateOrDelete="updateOrDelete"
      @chooseUpdateOrDelete="chooseUpdateOrDelete"
      :selectedID="selectedId"
    ></tabbar>

    <van-overlay :showLoding="showLoding"></van-overlay>
  </div>
</template>

<script>
import SearchBox from "@/components/common/search";
import Tabbar from "@/components/common/tabbar";
import ClassificationRules from "@/components/common/classificationRules"; // 法规分类
import RegulationsHierarchy from "@/components/common/regulationsHierarchy"; // 法规层级
import UploadFile from "@/components/common/uploadFile"; // 一键上传
import ListContent from "@/components/common/listContent";
import VanOverlay from "@/components/common/vanOverlay";
import Pagination from "@/components/common/pagination"; // 分页
import searchEnginePop from "@/components/newcommon/searchEnginePop";
import { commonToast } from "@/utils/lib/toast.js";

export default {
  data() {
    return {
      // 公众号二维码
      gzhewm: require("../../assets/indexImg/gzhewm.jpg"),
      showLoding: false,
      showSearchPopup: false, // 搜索引擎弹框
      flag: false,
      lists: [],
      data: {
        classifytag: [],
        minlock: 0,
      },
      dataC: {
        classifytag: [],
        minlock: 0,
      },
      dataI: {
        classifytag: [],
        minlock: 0,
      },
      minback: 0,
      minlock: 0,
      currentPage: 1,
      total: 0,

      minback5: 0,
      minlock5: 0,
      currentPage5: 1,
      total5: 0,

      commonTotal5: 0,
      currentCommonPage: 1,
      commonFlag: true,
      industryTotal5: 0,
      currentIndustryPage: 1,
      industryFlag: false,

      stime: "", // 开始时间
      etime: "", // 结束时间
      searchText: "", // 搜索关键字
      tagid: "",

      activeNames: ["1"],
      selectedId: "b",
      // 文件效力
      value1: "1",
      value5: "1",
      value6: "1",
      value7: "1",
      value8: "1",
      option1: [
        { text: "请选择", value: "1" },
        { text: "全文有效", value: "20" },
        { text: "尚未生效", value: "0" },
        { text: "部分废止(失效)", value: "30" },
        { text: "全文废止(失效)", value: "40" },
      ],

      // 综合检索
      search1: "",

      // 行业检索
      value2: "0",
      option2: [{ text: "请选择", value: "0" }],

      // 税收优惠检索
      radio: "1",
      disabled1: true,
      disabled2: false,
      disabled3: true,
      value11: "0", // 优惠项目
      option11: [{ text: "请选择", value: "0" }],
      value12: "0", // 优惠税种
      option12: [{ text: "请选择", value: "0" }],
      value13: "0", // 优惠行业
      option13: [{ text: "请选择", value: "0" }],

      // 条约检索
      value3: "0",
      option3: [{ text: "请选择", value: "0" }],

      // 进出口税收检索
      value4: "0",
      option4: [{ text: "请选择", value: "0" }],
      lists4: [],
      queryBtn: 0,
      doubleLists: false,
      commonLists: [], // 通用规定
      industryLists: [], // 专属规定
      countries: false, // 切换专属和国家(地区)

      updateDatas: {}, // 上传数据
      totalLists: 0, // 总的条数
      updateCommonDatas: {}, // 通用
      commonTotal5Lists: 0,
      updateIndustryDatas: {}, // 专属
      industryTotal5lists: 0,
      tagpc: [],
      t1: [],
      t2: [],
      t3: [],
      t1C: [],
      t2C: [],
      t3C: [],
      t1I: [],
      t2I: [],
      t3I: [],
      proAndCityData: {},
      proAndCityDataC: {},
      proAndCityDataI: {},
      SearchTimes: 1,
      isFilter: false,
      clickFlag: true, // 点击的是哪个的tagpc确定按钮
      clickFlagC: true,
      clickFlagI: true,
      fixedTagid: "", // 固定tagid
      fixedTagidC: "", // 固定tagid
      fixedTagidI: "", // 固定tagid
      clickConfirmBtn: true, // 带上tagpc
      clickConfirmBtnC: true, // 带上tagpc
      clickConfirmBtnI: true, // 带上tagpc
      showAllTagpc: [], // 保存tagpc
      showAllTagpcC: [],
      showAllTagpcI: [],
    };
  },
  components: {
    SearchBox,
    Tabbar,
    ClassificationRules,
    RegulationsHierarchy,
    UploadFile,
    ListContent,
    VanOverlay,
    Pagination,
    searchEnginePop,
  },
  computed: {
    userId() {
      return this.$store.state.user.userId;
    },
    wxunionid() {
      return sessionStorage.getItem("wxunionid");
    },
  },
  created() {
    this.$nextTick(() => {
      this.getSelectData();
      let dom = document.getElementById("goToHere2");
      dom.scrollIntoView();
    });
    // this.getData();
  },
  methods: {
    // 清除时间和搜索框的内容
    clearMsg() {
      this.$refs.searchBox.clearMsg();
    },
    // 选择省份城市后触发的事件
    getSearchLists(tagpc) {
      this.clickConfirmBtn = false;
      this.currentPage = 1;
      this.currentPage5 = 1;
      this.currentCommonPage = 1;
      this.currentIndustryPage = 1;
      this.isFilter = true;
      this.tagpc = tagpc;
      // if (tagpc.length > 0) {
      //   this.tagpc = tagpc
      // } else {
      //   this.tagpc = this.showAllTagpc
      // }
      if (this.queryBtn === 1) {
        this.getData(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 2 && this.commonFlag) {
        this.clickConfirmBtnC = false;
        // if (tagpc.length > 0) {
        //   this.tagpc = tagpc
        // } else {
        //   this.tagpc = this.showAllTagpcC
        // }
        if (this.clickFlagC) {
          this.tagid = this.fixedTagidC;
        }
        this.getData2Common(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 2 && this.industryFlag) {
        this.clickConfirmBtnI = false;
        // if (tagpc.length > 0) {
        //   this.tagpc = tagpc
        // } else {
        //   this.tagpc = this.showAllTagpcI
        // }
        if (this.clickFlagI) {
          this.tagid = this.fixedTagidI;
        }
        this.getData2Industry(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 3 && this.radio === "1") {
        if (this.clickFlag) {
          this.tagid = this.fixedTagid;
        }
        this.getDataRadio1(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 3 && this.radio === "2") {
        if (this.clickFlag) {
          this.tagid = this.fixedTagid;
        }
        this.getDataRadio2(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 3 && this.radio === "3" && this.commonFlag) {
        this.clickConfirmBtnC = false;
        // if (tagpc.length > 0) {
        //   this.tagpc = tagpc
        // } else {
        //   this.tagpc = this.showAllTagpcC
        // }
        if (this.clickFlagC) {
          this.tagid = this.fixedTagidC;
        }
        this.getDataRadio3CommonFiles(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (
        this.queryBtn === 3 &&
        this.radio === "3" &&
        this.industryFlag
      ) {
        this.clickConfirmBtnI = false;
        // if (tagpc.length > 0) {
        //   this.tagpc = tagpc
        // } else {
        //   this.tagpc = this.showAllTagpcI
        // }
        if (this.clickFlagI) {
          this.tagid = this.fixedTagidI;
        }
        this.getDataRadio3IndustryFiles(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 4 && this.commonFlag) {
        if (this.clickFlagC) {
          this.tagid = this.fixedTagidC;
        }
        this.getData4Common(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 4 && this.industryFlag) {
        if (this.clickFlagI) {
          this.tagid = this.fixedTagidI;
        }
        this.getData4Industry(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 5) {
        if (this.clickFlag) {
          this.tagid = this.fixedTagid;
        }
        this.getData5(this.tagid, this.stime, this.etime, this.searchText);
      }
    },
    // 获取综合检索的数据
    getData(tagid, stime, etime, searchText) {
      this.showLoding = true;
      let args = {
        searchtimes: this.SearchTimes, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text: this.search1 ? this.search1 : "",
          potence: this.value1 !== "1" ? this.value1 : "",
          icode: "",
          tcode: "",
          kcode: "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode,
          },
          dirid: "", // 上传目录ID，云端查询需要这个参数
          id: "",
        },
        second: [
          {
            text2: searchText && searchText !== undefined ? searchText : "",
            stime: stime && stime !== undefined ? stime : "",
            etime: etime && etime !== undefined ? etime : "",
          },
        ],
        fliter: {
          isfilter: this.isFilter,
          tagpc: this.tagpc,
          tagid: tagid && tagid !== undefined ? tagid : "",
        },
        pager: [
          {
            pagesize: 10, // 每页显示的条数
            pageindex: this.currentPage, // 当前页
          },
        ],
      };
      console.log("综合检索地方的数据====》", args);
      let nodes = this.$baseConfig.code;
      this.updateDatas = args;

      this.$http
        .reqGetGeneralFiles(args, nodes)
        .then((response) => {
          console.log("所有数据地方版搜索引擎的综合检索====》", response);
          this.showLoding = false;
          this.lists =
            response.tbls[0].items !== null ? response.tbls[0].items : [];
          this.t1 =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t1.length > 0
              ? response.tbls[0].divisiontag.t1
              : [];
          this.t2 =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t2.length > 0
              ? response.tbls[0].divisiontag.t2
              : [];
          this.t3 =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t3.length > 0
              ? response.tbls[0].divisiontag.t3
              : [];

          this.t2 = this.t2.sort((a, b) => a.id - b.id);
          this.t3 = this.t3.sort((a, b) => a.id - b.id);

          this.proAndCityData = {
            t1: this.t1.length > 0 ? this.t1 : [],
            t2: this.t2.length > 0 ? this.t2 : [],
            t3: this.t3.length > 0 ? this.t3 : [],
          };
          if (this.clickConfirmBtn) {
            this.tagpc = this.filterData(this.proAndCityData);
            this.showAllTagpc = [];
            this.showAllTagpc = this.tagpc;
          }

          this.total = Math.ceil(response.tbls[0].total / 10);
          this.totalLists = response.tbls[0].total; // 总的条数
          this.classifytag = response.tbls[0].classifytag;
          this.minback = response.tbls[0].minback;
          this.minlock = response.tbls[0].minlock;
          this.flag = true;
          this.data = {
            classifytag: this.classifytag,
            minlock: this.minlock ? this.minlock : 0,
          };

          this.$store.commit("search/setIsProtect", response.tbls[0].protect);
          this.$store.commit(
            "search/setWarningLevel",
            response.tbls[0].warninglevel
          );
          this.$store.commit(
            "search/setWarningText",
            response.tbls[0].warningtext
          );
          this.$store.dispatch("choose/updateLists", this.lists);

          this.bus.$emit("classifytagData", this.data);
        })
        .catch(() => {
          this.showLoding = false;
        });
    },
    // 第一次改变tagid的时候 循环城市数据 tagpc
    filterData(data) {
      let searchParameter = [];
      let national = [];
      let tagpc1 = [];
      let tagpc2 = [];
      if (data.t1.length > 0) {
        national = [{ p: "000000", c: "000000" }];
      }
      if (data.t2.length > 0) {
        // 循环省份
        data.t2.forEach((item) => {
          let stringlength = item.id.length;
          let pstring = item.id.substring(0, 6); // 截取前六位
          let nstring = item.id.substring(stringlength - 6, stringlength); // 截取后六位
          tagpc1.push({ p: pstring, c: nstring });
        });
      }
      if (data.t3.length > 0) {
        // 循环城市
        data.t3.forEach((item) => {
          if (item.children && item.children.length > 0) {
            item.children.forEach((item1) => {
              let stringlength = item1.id.length;
              let pstring = item1.id.substring(0, 6); // 截取前六位
              let nstring = item1.id.substring(stringlength - 6, stringlength); // 截取后六位
              tagpc2.push({ p: pstring, c: nstring });
            });
          }
        });
      }
      searchParameter = [...national, ...tagpc1, ...tagpc2];
      console.log("searchParameter", searchParameter);
      return searchParameter;
    },
    // 行业检索 通用
    getData2Common(tagid, stime, etime, searchText) {
      this.showLoding = true;
      let args = {
        searchtimes: this.SearchTimes, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text: "",
          potence: this.value5 !== "1" ? this.value5 : "",
          icode: this.value2 !== "0" ? this.value2 : "",
          tcode: "",
          kcode: "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode,
          },
          dirid: "", // 上传目录ID，云端查询需要这个参数
          id: "",
        },
        second: [
          {
            text2: searchText && searchText !== undefined ? searchText : "",
            stime: stime && stime !== undefined ? stime : "",
            etime: etime && etime !== undefined ? etime : "",
          },
        ],
        fliter: {
          isfilter: this.isFilter,
          tagpc: this.tagpc,
          tagid: tagid && tagid !== undefined ? tagid : "",
        },
        pager: [
          {
            pagesize: 10, // 当前页
            pageindex: this.currentCommonPage, // 每页显示的条数
          },
        ],
      };

      console.log("行业检索 通用的数据====》", args);
      let nodes = this.$baseConfig.code;
      this.updateCommonDatas = args;

      this.$http
        .reqGetIndustryCommonFiles(args, nodes)
        .then((response) => {
          console.log("行业检索 通用response", response);
          this.showLoding = false;
          this.commonLists =
            response.tbls[0].items !== null ? response.tbls[0].items : [];
          this.t1C =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t1.length > 0
              ? response.tbls[0].divisiontag.t1
              : [];
          this.t2C =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t2.length > 0
              ? response.tbls[0].divisiontag.t2
              : [];
          this.t3C =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t3.length > 0
              ? response.tbls[0].divisiontag.t3
              : [];

          this.t2C = this.t2C.sort((a, b) => a.id - b.id);
          this.t3C = this.t3C.sort((a, b) => a.id - b.id);

          this.proAndCityDataC = {
            t1: this.t1C.length > 0 ? this.t1C : [],
            t2: this.t2C.length > 0 ? this.t2C : [],
            t3: this.t3C.length > 0 ? this.t3C : [],
          };
          // console.log('行业检索 通用proAndCityData=>', this.proAndCityDataC)
          // this.$refs.regulations.processData(this.proAndCityDataC)
          if (this.clickConfirmBtnC) {
            this.tagpc = this.filterData(this.proAndCityDataC);
            this.showAllTagpcC = [];
            this.showAllTagpcC = this.tagpc;
          }

          this.commonTotal5 = Math.ceil(response.tbls[0].total / 10);
          this.commonTotal5Lists = response.tbls[0].total;
          this.classifytag = response.tbls[0].classifytag;
          this.fixedTagidC = this.getTagid(this.classifytag);

          this.minback5 = response.tbls[0].minback;
          this.minlock5 = response.tbls[0].minlock;
          this.flag = true;
          this.dataC = {
            classifytag: this.classifytag,
            // minlock: this.minlock5
            minlock: this.minlock5 ? this.minlock5 : 0,
          };

          this.$store.commit("search/setIsProtect", response.tbls[0].protect);
          this.$store.commit(
            "search/setWarningLevel",
            response.tbls[0].warninglevel
          );
          this.$store.commit(
            "search/setWarningText",
            response.tbls[0].warningtext
          );

          this.$store.dispatch("choose/updateCommonResult", this.commonLists);

          this.$refs.classification.alertBars5(this.dataC);
        })
        .catch(() => {
          this.showLoding = false;
        });
    },
    // 行业检索 专属
    getData2Industry(tagid, stime, etime, searchText) {
      this.showLoding = true;
      let args = {
        searchtimes: this.SearchTimes, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text: "",
          potence: this.value5 !== "1" ? this.value5 : "",
          icode: this.value2 !== "0" ? this.value2 : "",
          tcode: "",
          kcode: "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode,
          },
          dirid: "", // 上传目录ID，云端查询需要这个参数
          id: "",
        },
        second: [
          {
            text2: searchText && searchText !== undefined ? searchText : "",
            stime: stime && stime !== undefined ? stime : "",
            etime: etime && etime !== undefined ? etime : "",
          },
        ],
        fliter: {
          isfilter: this.isFilter,
          tagpc: this.tagpc,
          tagid: tagid && tagid !== undefined ? tagid : "",
        },
        pager: [
          {
            pagesize: 10, // 当前页
            pageindex: this.currentIndustryPage, // 每页显示的条数
          },
        ],
      };

      console.log("行业检索 专属的数据====》", args);
      let nodes = this.$baseConfig.code;
      this.updateIndustryDatas = args;

      this.$http
        .reqGetIndustryFiles(args, nodes)
        .then((response) => {
          console.log("行业检索 专属response", response);
          this.showLoding = false;
          this.industryLists =
            response.tbls[0].items !== null ? response.tbls[0].items : [];
          this.t1I =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t1.length > 0
              ? response.tbls[0].divisiontag.t1
              : [];
          this.t2I =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t2.length > 0
              ? response.tbls[0].divisiontag.t2
              : [];
          this.t3I =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t3.length > 0
              ? response.tbls[0].divisiontag.t3
              : [];
          this.t2I = this.t2I.sort((a, b) => a.id - b.id);
          this.t3I = this.t3I.sort((a, b) => a.id - b.id);
          this.proAndCityDataI = {
            t1: this.t1I.length > 0 ? this.t1I : [],
            t2: this.t2I.length > 0 ? this.t2I : [],
            t3: this.t3I.length > 0 ? this.t3I : [],
          };
          if (this.clickConfirmBtnI) {
            this.tagpc = this.filterData(this.proAndCityDataI);
            this.showAllTagpcI = [];
            this.showAllTagpcI = this.tagpc;
          }

          this.industryTotal5 = Math.ceil(response.tbls[0].total / 10);
          this.industryTotal5lists = response.tbls[0].total;
          this.classifytag = response.tbls[0].classifytag;
          this.fixedTagidI = this.getTagid(this.classifytag);

          this.minback5 = response.tbls[0].minback;
          this.minlock5 = response.tbls[0].minlock;
          this.flag = true;
          this.dataI = {
            classifytag: this.classifytag,
            minlock: this.minlock5 ? this.minlock5 : 0,
          };

          this.$store.commit("search/setIsProtect", response.tbls[0].protect);
          this.$store.commit(
            "search/setWarningLevel",
            response.tbls[0].warninglevel
          );
          this.$store.commit(
            "search/setWarningText",
            response.tbls[0].warningtext
          );

          this.$store.dispatch(
            "choose/updateIndustryResult",
            this.industryLists
          );
          this.$refs.classification.alertBars5(this.dataI);
        })
        .catch(() => {
          this.showLoding = false;
        });
    },
    // 税收优惠项目
    getDataRadio1(tagid, stime, etime, searchText) {
      this.showLoding = true;
      let args = {
        searchtimes: this.SearchTimes, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text: "",
          potence: this.value6 !== "1" ? this.value6 : "",
          icode: "",
          tcode: "",
          kcode: this.value11 !== "0" ? this.value11 : "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode,
          },
          dirid: "", // 上传目录ID，云端查询需要这个参数
          id: "",
        },
        second: [
          {
            text2: searchText && searchText !== undefined ? searchText : "",
            stime: stime && stime !== undefined ? stime : "",
            etime: etime && etime !== undefined ? etime : "",
          },
        ],
        fliter: {
          isfilter: this.isFilter,
          tagpc: this.tagpc,
          tagid: tagid && tagid !== undefined ? tagid : "",
        },
        pager: [
          {
            pagesize: 10, // 当前页
            pageindex: this.currentPage5, // 每页显示的条数
          },
        ],
      };

      console.log("税收优惠项目的数据====》", args);
      let nodes = this.$baseConfig.code;
      this.updateDatas = args;
      this.$http
        .reqGetTaxBreakFiles_item(args, nodes)
        .then((response) => {
          console.log("税收优惠项目1111", response);
          this.showLoding = false;
          this.lists4 =
            response.tbls[0].items !== null ? response.tbls[0].items : [];
          this.t1 =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t1.length > 0
              ? response.tbls[0].divisiontag.t1
              : [];
          this.t2 =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t2.length > 0
              ? response.tbls[0].divisiontag.t2
              : [];
          this.t3 =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t3.length > 0
              ? response.tbls[0].divisiontag.t3
              : [];
          this.t2 = this.t2.sort((a, b) => a.id - b.id);
          this.t3 = this.t3.sort((a, b) => a.id - b.id);
          this.proAndCityData = {
            t1: this.t1.length > 0 ? this.t1 : [],
            t2: this.t2.length > 0 ? this.t2 : [],
            t3: this.t3.length > 0 ? this.t3 : [],
          };
          if (this.clickConfirmBtn) {
            this.tagpc = this.filterData(this.proAndCityData);
            this.showAllTagpc = [];
            this.showAllTagpc = this.tagpc;
          }

          this.total5 = Math.ceil(response.tbls[0].total / 10);
          this.totalLists = response.tbls[0].total; // 总的条数

          this.classifytag = response.tbls[0].classifytag;

          this.fixedTagid = this.getTagid(this.classifytag);

          this.minback5 = response.tbls[0].minback;
          this.minlock5 = response.tbls[0].minlock;
          this.flag = true;
          this.data = {
            classifytag: this.classifytag,
            minlock: this.minlock5 ? this.minlock5 : 0,
          };

          this.$store.commit("search/setIsProtect", response.tbls[0].protect);
          this.$store.commit(
            "search/setWarningLevel",
            response.tbls[0].warninglevel
          );
          this.$store.commit(
            "search/setWarningText",
            response.tbls[0].warningtext
          );

          this.$store.dispatch("choose/updateLists", this.lists4);

          this.$refs.classification.alertBars5(this.data);
        })
        .catch(() => {
          this.showLoding = false;
        });
    },
    // 税收优惠税种
    getDataRadio2(tagid, stime, etime, searchText) {
      this.showLoding = true;
      let args = {
        searchtimes: this.SearchTimes, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text: "",
          potence: this.value6 !== "1" ? this.value6 : "",
          icode: "",
          tcode: "",
          kcode: this.value12 !== "0" ? this.value12 : "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode,
          },
          dirid: "", // 上传目录ID，云端查询需要这个参数
          id: "",
        },
        second: [
          {
            text2: searchText && searchText !== undefined ? searchText : "",
            stime: stime && stime !== undefined ? stime : "",
            etime: etime && etime !== undefined ? etime : "",
          },
        ],
        fliter: {
          isfilter: this.isFilter,
          tagpc: this.tagpc,
          tagid: tagid && tagid !== undefined ? tagid : "",
        },
        pager: [
          {
            pagesize: 10, // 当前页
            pageindex: this.currentPage5, // 每页显示的条数
          },
        ],
      };

      console.log("税收优惠项目的数据====》", args);

      let nodes = this.$baseConfig.code;
      this.updateDatas = args;
      this.$http
        .reqGetTaxBreakFiles_taxes(args, nodes)
        .then((response) => {
          console.log("税收优惠税种2222", response);
          this.showLoding = false;
          this.lists4 =
            response.tbls[0].items !== null ? response.tbls[0].items : [];
          this.t1 =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t1.length > 0
              ? response.tbls[0].divisiontag.t1
              : [];
          this.t2 =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t2.length > 0
              ? response.tbls[0].divisiontag.t2
              : [];
          this.t3 =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t3.length > 0
              ? response.tbls[0].divisiontag.t3
              : [];
          this.t2 = this.t2.sort((a, b) => a.id - b.id);
          this.t3 = this.t3.sort((a, b) => a.id - b.id);
          this.proAndCityData = {
            t1: this.t1.length > 0 ? this.t1 : [],
            t2: this.t2.length > 0 ? this.t2 : [],
            t3: this.t3.length > 0 ? this.t3 : [],
          };
          if (this.clickConfirmBtn) {
            this.tagpc = this.filterData(this.proAndCityData);
            this.showAllTagpc = [];
            this.showAllTagpc = this.tagpc;
          }

          this.total5 = Math.ceil(response.tbls[0].total / 10);
          this.totalLists = response.tbls[0].total; // 总的条数
          this.classifytag = response.tbls[0].classifytag;

          this.fixedTagid = this.getTagid(this.classifytag);

          this.minback5 = response.tbls[0].minback;
          this.minlock5 = response.tbls[0].minlock;
          this.flag = true;
          this.data = {
            classifytag: this.classifytag,
            minlock: this.minlock5 ? this.minlock5 : 0,
          };

          this.$store.commit("search/setIsProtect", response.tbls[0].protect);
          this.$store.commit(
            "search/setWarningLevel",
            response.tbls[0].warninglevel
          );
          this.$store.commit(
            "search/setWarningText",
            response.tbls[0].warningtext
          );

          this.$store.dispatch("choose/updateLists", this.lists4);

          this.$refs.classification.alertBars5(this.data);
        })
        .catch(() => {
          this.showLoding = false;
        });
    },
    // 税收优惠行业 税收优惠行业通用
    getDataRadio3CommonFiles(tagid, stime, etime, searchText) {
      this.showLoding = true;
      let args = {
        searchtimes: this.SearchTimes, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text: "",
          potence: this.value6 !== "1" ? this.value6 : "",
          icode: "",
          tcode: "",
          kcode: this.value13 !== "0" ? this.value13 : "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode,
          },
          dirid: "", // 上传目录ID，云端查询需要这个参数
          id: "",
        },
        second: [
          {
            text2: searchText && searchText !== undefined ? searchText : "",
            stime: stime && stime !== undefined ? stime : "",
            etime: etime && etime !== undefined ? etime : "",
          },
        ],
        fliter: {
          isfilter: this.isFilter,
          tagpc: this.tagpc,
          tagid: tagid && tagid !== undefined ? tagid : "",
        },
        pager: [
          {
            pagesize: 10, // 当前页
            pageindex: this.currentCommonPage, // 每页显示的条数
          },
        ],
      };

      let nodes = this.$baseConfig.code;
      this.updateCommonDatas = args;
      this.$http
        .reqGetTaxBreakIndustryCommonFiles(args, nodes)
        .then((response) => {
          console.log("税收优惠检索的查询按钮222", response);
          this.showLoding = false;
          this.commonLists =
            response.tbls[0].items !== null ? response.tbls[0].items : [];
          this.t1C =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t1.length > 0
              ? response.tbls[0].divisiontag.t1
              : [];
          this.t2C =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t2.length > 0
              ? response.tbls[0].divisiontag.t2
              : [];
          this.t3C =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t3.length > 0
              ? response.tbls[0].divisiontag.t3
              : [];
          this.t2C = this.t2C.sort((a, b) => a.id - b.id);
          this.t3C = this.t3C.sort((a, b) => a.id - b.id);
          this.proAndCityDataC = {
            t1: this.t1C.length > 0 ? this.t1C : [],
            t2: this.t2C.length > 0 ? this.t2C : [],
            t3: this.t3C.length > 0 ? this.t3C : [],
          };
          if (this.clickConfirmBtnC) {
            this.tagpc = this.filterData(this.proAndCityDataC);
            this.showAllTagpcC = [];
            this.showAllTagpcC = this.tagpc;
          }

          this.commonTotal5 = Math.ceil(response.tbls[0].total / 10);
          this.commonTotal5Lists = response.tbls[0].total;
          this.classifytag = response.tbls[0].classifytag;

          this.fixedTagidC = this.getTagid(this.classifytag);

          this.minback5 = response.tbls[0].minback;
          this.minlock5 = response.tbls[0].minlock;
          this.flag = true;
          this.dataC = {
            classifytag: this.classifytag,
            minlock: this.minlock5 ? this.minlock5 : 0,
          };

          this.$store.commit("search/setIsProtect", response.tbls[0].protect);
          this.$store.commit(
            "search/setWarningLevel",
            response.tbls[0].warninglevel
          );
          this.$store.commit(
            "search/setWarningText",
            response.tbls[0].warningtext
          );
          this.$store.dispatch("choose/updateCommonResult", this.commonLists);
          this.$refs.classification.alertBars5(this.dataC);
        })
        .catch(() => {
          this.showLoding = false;
        });
    },
    //  税收优惠行业 税收优惠行业专属
    getDataRadio3IndustryFiles(tagid, stime, etime, searchText) {
      this.showLoding = true;
      let args = {
        searchtimes: this.SearchTimes, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text: "",
          potence: this.value6 !== "1" ? this.value6 : "",
          icode: "",
          tcode: "",
          kcode: this.value13 !== "0" ? this.value13 : "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode,
          },
          dirid: "", // 上传目录ID，云端查询需要这个参数
          id: "",
        },
        second: [
          {
            text2: searchText && searchText !== undefined ? searchText : "",
            stime: stime && stime !== undefined ? stime : "",
            etime: etime && etime !== undefined ? etime : "",
          },
        ],
        fliter: {
          isfilter: this.isFilter,
          tagpc: this.tagpc,
          tagid: tagid && tagid !== undefined ? tagid : "",
        },
        pager: [
          {
            pagesize: 10, // 当前页
            pageindex: this.currentIndustryPage, // 每页显示的条数
          },
        ],
      };

      console.log("税收优惠检索的数据====》", args);
      let nodes = this.$baseConfig.code;
      this.updateIndustryDatas = args;
      this.$http
        .reqGetTaxBreakIndustryFiles(args, nodes)
        .then((response) => {
          console.log("税收优惠检索的查询按钮222", response);
          this.showLoding = false;
          this.industryLists =
            response.tbls[0].items !== null ? response.tbls[0].items : [];
          this.t1I =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t1.length > 0
              ? response.tbls[0].divisiontag.t1
              : [];
          this.t2I =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t2.length > 0
              ? response.tbls[0].divisiontag.t2
              : [];
          this.t3I =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t3.length > 0
              ? response.tbls[0].divisiontag.t3
              : [];
          this.t2I = this.t2I.sort((a, b) => a.id - b.id);
          this.t3I = this.t3I.sort((a, b) => a.id - b.id);
          this.proAndCityDataI = {
            t1: this.t1I.length > 0 ? this.t1I : [],
            t2: this.t2I.length > 0 ? this.t2I : [],
            t3: this.t3I.length > 0 ? this.t3I : [],
          };
          if (this.clickConfirmBtnI) {
            this.tagpc = this.filterData(this.proAndCityDataI);
            this.showAllTagpcI = [];
            this.showAllTagpcI = this.tagpc;
          }

          this.industryTotal5 = Math.ceil(response.tbls[0].total / 10);
          this.industryTotal5lists = response.tbls[0].total;
          this.classifytag = response.tbls[0].classifytag;

          this.fixedTagidI = this.getTagid(this.classifytag);

          this.minback5 = response.tbls[0].minback;
          this.minlock5 = response.tbls[0].minlock;
          this.flag = true;
          this.dataI = {
            classifytag: this.classifytag,
            minlock: this.minlock5 ? this.minlock5 : 0,
          };

          this.$store.dispatch(
            "choose/updateIndustryResult",
            this.industryLists
          );
          this.$refs.classification.alertBars5(this.dataI);
        })
        .catch(() => {
          this.showLoding = false;
        });
    },
    // 条约检索 通用
    getData4Common(tagid, stime, etime, searchText) {
      this.showLoding = true;
      let args = {
        searchtimes: this.SearchTimes, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text: "",
          potence: this.value7 !== "1" ? this.value7 : "",
          icode: "",
          tcode: "",
          kcode: "",
          country: this.value3 !== "0" ? this.value3 : "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode,
          },
          dirid: "", // 上传目录ID，云端查询需要这个参数
          id: "",
        },
        second: [
          {
            text2: searchText && searchText !== undefined ? searchText : "",
            stime: stime && stime !== undefined ? stime : "",
            etime: etime && etime !== undefined ? etime : "",
          },
        ],
        fliter: {
          isfilter: this.isFilter,
          tagpc: this.tagpc,
          tagid: tagid && tagid !== undefined ? tagid : "",
        },
        pager: [
          {
            pagesize: 10, // 当前页
            pageindex: this.currentCommonPage, // 每页显示的条数
          },
        ],
      };

      console.log("条约检索 通用的数据====》", args);
      let nodes = this.$baseConfig.code;
      this.updateCommonDatas = args;
      this.$http
        .reqGetCommonTreatyFiles(args, nodes)
        .then((response) => {
          console.log("条约检索 通用", response);
          this.showLoding = false;
          this.commonLists =
            response.tbls[0].items !== null ? response.tbls[0].items : [];
          this.t1C =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t1.length > 0
              ? response.tbls[0].divisiontag.t1
              : [];
          this.t2C =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t2.length > 0
              ? response.tbls[0].divisiontag.t2
              : [];
          this.t3C =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t3.length > 0
              ? response.tbls[0].divisiontag.t3
              : [];
          this.proAndCityDataC = {
            t1: this.t1C.length > 0 ? this.t1C : [],
            t2: this.t2C.length > 0 ? this.t2C : [],
            t3: this.t3C.length > 0 ? this.t3C : [],
          };
          if (this.clickConfirmBtn) {
            this.tagpc = this.filterData(this.proAndCityDataC);
            this.showAllTagpcC = [];
            this.showAllTagpcC = this.tagpc;
          }

          this.commonTotal5 = Math.ceil(response.tbls[0].total / 10);
          this.commonTotal5Lists = response.tbls[0].total;
          this.classifytag = response.tbls[0].classifytag;
          this.fixedTagidC = this.getTagid(this.classifytag);

          this.minback5 = response.tbls[0].minback;
          this.minlock5 = response.tbls[0].minlock;
          this.flag = true;
          this.dataC = {
            classifytag: this.classifytag,
            minlock: this.minlock5 ? this.minlock5 : 0,
          };

          this.$store.commit("search/setIsProtect", response.tbls[0].protect);
          this.$store.commit(
            "search/setWarningLevel",
            response.tbls[0].warninglevel
          );
          this.$store.commit(
            "search/setWarningText",
            response.tbls[0].warningtext
          );

          this.$store.dispatch("choose/updateCommonResult", this.commonLists);
          this.$refs.classification.alertBars5(this.dataC);
        })
        .catch(() => {
          this.showLoding = false;
        });
    },
    // 条约检索 国家(地区)
    getData4Industry(tagid, stime, etime, searchText) {
      this.showLoding = true;
      let args = {
        searchtimes: this.SearchTimes, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text: "",
          potence: this.value7 !== "1" ? this.value7 : "",
          icode: "",
          tcode: "",
          kcode: "",
          country: this.value3 !== "0" ? this.value3 : "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode,
          },
          dirid: "", // 上传目录ID，云端查询需要这个参数
          id: "",
        },
        second: [
          {
            text2: searchText && searchText !== undefined ? searchText : "",
            stime: stime && stime !== undefined ? stime : "",
            etime: etime && etime !== undefined ? etime : "",
          },
        ],
        fliter: {
          isfilter: this.isFilter,
          tagpc: this.tagpc,
          tagid: tagid && tagid !== undefined ? tagid : "",
        },
        pager: [
          {
            pagesize: 10, // 当前页
            pageindex: this.currentIndustryPage, // 每页显示的条数
          },
        ],
      };

      console.log("条约检索 国家(地区)====》", args);
      let nodes = this.$baseConfig.code;
      this.updateIndustryDatas = args;
      this.$http
        .reqGetTreatyFiles(args, nodes)
        .then((response) => {
          console.log("条约检索 国家(地区)", response);
          this.showLoding = false;
          this.industryLists =
            response.tbls[0].items !== null ? response.tbls[0].items : [];
          this.t1I =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t1.length > 0
              ? response.tbls[0].divisiontag.t1
              : [];
          this.t2I =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t2.length > 0
              ? response.tbls[0].divisiontag.t2
              : [];
          this.t3I =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t3.length > 0
              ? response.tbls[0].divisiontag.t3
              : [];
          this.proAndCityDataI = {
            t1: this.t1I.length > 0 ? this.t1I : [],
            t2: this.t2I.length > 0 ? this.t2I : [],
            t3: this.t3I.length > 0 ? this.t3I : [],
          };
          if (this.clickConfirmBtn) {
            this.tagpc = this.filterData(this.proAndCityDataI);
            this.showAllTagpcI = [];
            this.showAllTagpcI = this.tagpc;
          }

          this.industryTotal5 = Math.ceil(response.tbls[0].total / 10);
          this.industryTotal5lists = response.tbls[0].total;
          this.classifytag = response.tbls[0].classifytag;
          this.fixedTagidI = this.getTagid(this.classifytag);

          this.minback5 = response.tbls[0].minback;
          this.minlock5 = response.tbls[0].minlock;
          this.flag = true;
          this.dataI = {
            classifytag: this.classifytag,
            minlock: this.minlock5 ? this.minlock5 : 0,
          };

          this.$store.commit("search/setIsProtect", response.tbls[0].protect);
          this.$store.commit(
            "search/setWarningLevel",
            response.tbls[0].warninglevel
          );
          this.$store.commit(
            "search/setWarningText",
            response.tbls[0].warningtext
          );

          this.$store.dispatch(
            "choose/updateIndustryResult",
            this.industryLists
          );
          this.$refs.classification.alertBars5(this.dataI);
        })
        .catch(() => {
          this.showLoding = false;
        });
    },
    // 获取进出口税收检索的数据
    getData5(tagid, stime, etime, searchText) {
      this.showLoding = true;
      let args = {
        searchtimes: this.SearchTimes, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text: "",
          potence: this.value8 !== "1" ? this.value8 : "",
          icode: "",
          tcode: "",
          kcode: this.value4 !== "0" ? this.value4 : "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode,
          },
          dirid: "", // 上传目录ID，云端查询需要这个参数
          id: "",
        },
        second: [
          {
            text2: searchText && searchText !== undefined ? searchText : "",
            stime: stime && stime !== undefined ? stime : "",
            etime: etime && etime !== undefined ? etime : "",
          },
        ],
        fliter: {
          isfilter: this.isFilter,
          tagpc: this.tagpc,
          tagid: tagid && tagid !== undefined ? tagid : "",
        },
        pager: [
          {
            pagesize: 10, // 当前页
            pageindex: this.currentPage5, // 每页显示的条数
          },
        ],
      };

      console.log("进出口税收检索的数据====》", args);
      let nodes = this.$baseConfig.code;
      this.updateDatas = args;

      this.$http
        .reqGetInOutFiles(args, nodes)
        .then((response) => {
          this.flag = true;
          console.log("进出口返回的数据response", response);
          this.showLoding = false;
          this.lists4 =
            response.tbls[0].items !== null ? response.tbls[0].items : [];
          this.t1 =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t1.length > 0
              ? response.tbls[0].divisiontag.t1
              : [];
          this.t2 =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t2.length > 0
              ? response.tbls[0].divisiontag.t2
              : [];
          this.t3 =
            response.tbls[0].divisiontag.length !== 0 &&
            response.tbls[0].divisiontag.t3.length > 0
              ? response.tbls[0].divisiontag.t3
              : [];
          this.t2 = this.t2.sort((a, b) => a.id - b.id);
          this.t3 = this.t3.sort((a, b) => a.id - b.id);
          this.proAndCityData = {
            t1: this.t1.length > 0 ? this.t1 : [],
            t2: this.t2.length > 0 ? this.t2 : [],
            t3: this.t3.length > 0 ? this.t3 : [],
          };
          if (this.clickConfirmBtn) {
            this.tagpc = this.filterData(this.proAndCityData);
            this.showAllTagpc = [];
            this.showAllTagpc = this.tagpc;
          }

          this.total5 = Math.ceil(response.tbls[0].total / 10);
          this.totalLists = response.tbls[0].total; // 总的条数
          this.classifytag = response.tbls[0].classifytag;
          this.fixedTagid = this.getTagid(this.classifytag);

          this.minback5 = response.tbls[0].minback;
          this.minlock5 = response.tbls[0].minlock;
          this.data = {
            classifytag: this.classifytag,
            minlock: this.minlock5 ? this.minlock5 : 0,
          };

          this.$store.commit("search/setIsProtect", response.tbls[0].protect);
          this.$store.commit(
            "search/setWarningLevel",
            response.tbls[0].warninglevel
          );
          this.$store.commit(
            "search/setWarningText",
            response.tbls[0].warningtext
          );

          this.$store.dispatch("choose/updateLists", this.lists4);

          this.$refs.classification.alertBars5(this.data);
        })
        .catch(() => {
          this.showLoding = false;
        });
    },
    // 获取选中的tagid 点击法规层级时能够保持选中状态
    getTagid(data) {
      // console.log('固定获取选中的tagiddata=====>', data)
      let fixedTagid = "";
      data.forEach((item) => {
        if (item.children && item.children.length > 1) {
          fixedTagid = item.id;
        } else if (
          item.children &&
          item.children.length === 1 &&
          item.children[0].children
        ) {
          item.children.forEach((item1) => {
            if (item1.children && item1.children.length > 1) {
              fixedTagid = item1.id;
            } else if (
              item1.children &&
              item1.children.length === 1 &&
              item1.children[0].children
            ) {
              item1.children.forEach((item2) => {
                if (item2.children && item2.children.length > 1) {
                  fixedTagid = item2.id;
                } else if (
                  item2.children &&
                  item2.children.length === 1 &&
                  item2.children[0].children
                ) {
                  item2.children.forEach((item3) => {
                    if (item3.children && item3.children.length > 1) {
                      fixedTagid = item3.id;
                    } else if (
                      item3.children &&
                      item3.children.length === 1 &&
                      item3.children[0].children
                    ) {
                      item3.children.forEach((item4) => {
                        console.log(item4);
                      });
                    } else {
                      fixedTagid = item3.children[0].id;
                    }
                  });
                } else {
                  fixedTagid = item2.children[0].id;
                }
              });
            } else {
              fixedTagid = item1.children[0].id;
            }
          });
        } else {
          fixedTagid = item.children[0].id;
        }
      });
      return fixedTagid;
    },
    // 查询按钮
    searchDatas(num) {
      this.clickConfirmBtn = true;
      this.clickConfirmBtnC = true;
      this.clickConfirmBtnI = true;
      this.$refs.classification.clearSearchValue();
      this.$refs.classification.backNum = 0;
      this.clickFlag = true;
      this.clickFlagC = true;
      this.clickFlagI = true;
      this.flag = true;
      this.SearchTimes = 1;
      this.isFilter = false;
      this.queryBtn = num;
      this.lists = [];
      this.lists4 = [];
      this.commonLists = []; // 通用规定
      this.industryLists = []; // 专属规定
      this.currentPage = 1;
      this.currentPage5 = 1;
      this.currentCommonPage = 1;
      this.currentIndustryPage = 1;
      this.showSearchPopup = false;
      (this.stime = ""), // 开始时间
        (this.etime = ""), // 结束时间
        (this.searchText = ""), // 搜索关键字
        (this.tagid = ""),
        (this.$refs.searchBox.keyword = "");
      this.$refs.searchBox.startAndEndTimeOne = "";
      this.$refs.searchBox.startAndEndTimeTwo = "";
      this.tagpc = [];
      this.t1 = [];
      this.t2 = [];
      this.t3 = [];
      this.data = {};
      this.dataC = {};
      this.dataI = {};

      // 清除数据
      this.backStatus();
      this.$refs.listCont.toggle([]);

      if (this.flag) {
        this.$refs.classification.changeFixedBtn();
      }

      console.log("num", num);
      if (num === 1) {
        // 综合检索的查询按钮
        console.log("this.search1, this.value1", this.search1, this.value1);
        if (!this.search1 && this.value1 === "1") {
          commonToast("查询内容不能为空", this);
          // this.showSearchPopup = true;
        } else {
          this.showSearchPopup = false;
          this.currentPage = 1;
          this.getData();
          if (this.flag) {
            this.$refs.classification.alertBars1();
          }
        }
      } else if (num === 2) {
        // 行业检索的查询按钮
        if (this.value2 === "0" && this.value5 === "1") {
          commonToast("查询内容不能为空", this);
          // this.showSearchPopup = true;
        } else {
          this.showSearchPopup = false;
          this.doubleLists = true;
          this.countries = false;
          this.getData2Common();
          this.getData2Industry();
        }
      } else if (num === 3) {
        // 税收优惠检索的查询按钮
        if (this.radio === "1") {
          if (this.value11 === "0" && this.value6 === "1") {
            commonToast("查询内容不能为空", this);
            // this.showSearchPopup = true;
          } else {
            this.showSearchPopup = false;
            this.getDataRadio1();
          }
        } else if (this.radio === "2") {
          if (this.value12 === "0" && this.value6 === "1") {
            commonToast("查询内容不能为空", this);
            // this.showSearchPopup = true;
          } else {
            this.showSearchPopup = false;
            this.getDataRadio2();
          }
        } else if (this.radio === "3") {
          if (this.value13 === "0" && this.value6 === "1") {
            commonToast("查询内容不能为空", this);
            // this.showSearchPopup = true;
          } else {
            this.showSearchPopup = false;
            this.doubleLists = true;
            this.countries = false;
            this.getDataRadio3CommonFiles();
            this.getDataRadio3IndustryFiles();
          }
        }
      } else if (num === 4) {
        // 条约检索的查询按钮
        if (this.value3 === "0" && this.value7 === "1") {
          commonToast("查询内容不能为空", this);
          // this.showSearchPopup = true;
        } else {
          this.showSearchPopup = false;
          this.doubleLists = true;
          this.countries = true;
          this.getData4Common();
          this.getData4Industry();
        }
      } else if (num === 5) {
        // 进出口税收检索的查询按钮
        if (this.value4 === "0" && this.value8 === "1") {
          commonToast("查询内容不能为空", this);
          // this.showSearchPopup = true;
        } else {
          this.showSearchPopup = false;
          this.currentPage5 = 1;
          this.getData5();
        }
      }
    },
    // 法规分类触发的事件
    showGetData(data) {
      // console.log('法规分类触发的事件data===>', data)
      this.showData = data;
      this.tagid = data.tagid;
      if (this.queryBtn === 1) {
        this.getData(this.tagid, data.stime, data.etime, data.searchText);
      } else if (this.queryBtn === 2 && this.commonFlag) {
        this.getData2Common(
          this.tagid,
          data.stime,
          data.etime,
          data.searchText
        );
      } else if (this.queryBtn === 2 && this.industryFlag) {
        this.getData2Industry(
          this.tagid,
          data.stime,
          data.etime,
          data.searchText
        );
      } else if (this.queryBtn === 3 && this.radio === "1") {
        this.getDataRadio1(this.tagid, data.stime, data.etime, data.searchText);
      } else if (this.queryBtn === 3 && this.radio === "2") {
        this.getDataRadio2(this.tagid, data.stime, data.etime, data.searchText);
      } else if (this.queryBtn === 3 && this.radio === "3" && this.commonFlag) {
        this.getDataRadio3CommonFiles(
          this.tagid,
          data.stime,
          data.etime,
          data.searchText
        );
      } else if (
        this.queryBtn === 3 &&
        this.radio === "3" &&
        this.industryFlag
      ) {
        this.getDataRadio3IndustryFiles(
          this.tagid,
          data.stime,
          data.etime,
          data.searchText
        );
      } else if (this.queryBtn === 4 && this.commonFlag) {
        this.getData4Common(
          this.tagid,
          data.stime,
          data.etime,
          data.searchText
        );
      } else if (this.queryBtn === 4 && this.industryFlag) {
        this.getData4Industry(
          this.tagid,
          data.stime,
          data.etime,
          data.searchText
        );
      } else if (this.queryBtn === 5) {
        this.getData5(this.tagid, data.stime, data.etime, data.searchText);
      }
    },
    // 点击弹出搜索导航框
    alertBars() {
      let active = this.$store.state.commonSearchData.active;
      if (!this.flag) {
        // this.$refs.classification.alertBars()
        this.$refs.classification.alertBar3();
      } else {
        if (this.queryBtn === 1) {
          // this.$refs.classification.alertBars()
          if (
            this.lists.length === 0 &&
            this.classifytag.length === 0 &&
            this.totalLists === 0
          ) {
            this.$refs.classification.alertBar3();
          } else {
            this.$refs.classification.alertBars();
          }
        } else if (
          this.queryBtn === 3 &&
          (this.radio === "1" || this.radio === "2")
        ) {
          // this.$refs.classification.commonSelected(this.data)
          if (
            this.lists4.length === 0 &&
            this.classifytag.length === 0 &&
            this.totalLists === 0
          ) {
            this.$refs.classification.alertBar3();
          } else {
            this.$refs.classification.commonSelected(this.data);
          }
        } else if (this.queryBtn === 5) {
          // this.$refs.classification.commonSelected(this.data)
          if (
            this.lists4.length === 0 &&
            this.classifytag.length === 0 &&
            this.totalLists === 0
          ) {
            this.$refs.classification.alertBar3();
          } else {
            this.$refs.classification.commonSelected(this.data);
          }
        } else if (this.doubleLists && active === 0) {
          // this.$refs.classification.commonSelected(this.dataC)
          if (
            this.commonLists.length === 0 &&
            this.classifytag.length === 0 &&
            this.commonTotal5Lists === 0
          ) {
            this.$refs.classification.alertBar3();
          } else {
            this.$refs.classification.commonSelected(this.dataC);
          }
        } else if (this.doubleLists && active === 1) {
          // this.$refs.classification.commonSelected(this.dataI)
          if (
            this.industryLists.length === 0 &&
            this.classifytag.length === 0 &&
            this.industryTotal5lists === 0
          ) {
            this.$refs.classification.alertBar3();
          } else {
            this.$refs.classification.commonSelected(this.dataI);
          }
        }
      }
    },
    // 点击弹出法规层级框
    alertCengji() {
      let active = this.$store.state.commonSearchData.active;
      if (this.flag && (this.queryBtn === 1 || this.queryBtn === 5)) {
        this.$refs.regulations.processData(this.proAndCityData);
      } else if (
        this.flag &&
        this.queryBtn === 3 &&
        (this.radio === "1" || this.radio === "2")
      ) {
        this.$refs.regulations.processData(this.proAndCityData);
      } else if (this.flag && this.doubleLists && active === 0) {
        this.$refs.regulations.processData1(this.proAndCityDataC);
      } else if (this.flag && this.doubleLists && active === 1) {
        this.$refs.regulations.processData1(this.proAndCityDataI);
      } else {
        this.$notify({
          duration: 5000,
          color: "#fff",
          background: "#F27852",
          message: "请先搜索文件后使用",
        });
      }
    },
    // 点击一键上传
    updateOrDelete() {
      console.log("点击了地方版的一键上传this.tagpc6666==>", this.tagpc);
      if (this.userId) {
        if (this.queryBtn === 0) {
          this.$notify({
            duration: 5000,
            color: "#fff",
            background: "#F27852",
            message: "请先搜索文件后上传",
          });
        } else if (this.queryBtn === 1) {
          this.updateDatas.fliter.tagpc = this.tagpc;
          this.$refs.uploadFile.updateOrDelete(this.updateDatas, "综合检索");
        } else if (this.queryBtn === 2 && this.commonFlag) {
          this.updateCommonDatas.fliter.tagpc = this.tagpc;
          this.$refs.uploadFile.updateOrDelete(
            this.updateCommonDatas,
            "行业检索通用规定"
          );
        } else if (this.queryBtn === 2 && this.industryFlag) {
          this.updateIndustryDatas.fliter.tagpc = this.tagpc;
          this.$refs.uploadFile.updateOrDelete(
            this.updateIndustryDatas,
            "行业检索专属规定"
          );
        } else if (this.queryBtn === 3 && this.radio === "1") {
          this.updateDatas.fliter.tagpc = this.tagpc;
          this.$refs.uploadFile.updateOrDelete(
            this.updateDatas,
            "税收优惠项目"
          );
        } else if (this.queryBtn === 3 && this.radio === "2") {
          this.updateDatas.fliter.tagpc = this.tagpc;
          this.$refs.uploadFile.updateOrDelete(
            this.updateDatas,
            "税收优惠税种"
          );
        } else if (
          this.queryBtn === 3 &&
          this.radio === "3" &&
          this.commonFlag
        ) {
          this.updateCommonDatas.fliter.tagpc = this.tagpc;
          this.$refs.uploadFile.updateOrDelete(
            this.updateCommonDatas,
            "税收优惠行业通用"
          );
        } else if (
          this.queryBtn === 3 &&
          this.radio === "3" &&
          this.industryFlag
        ) {
          this.updateIndustryDatas.fliter.tagpc = this.tagpc;
          this.$refs.uploadFile.updateOrDelete(
            this.updateIndustryDatas,
            "税收优惠行业专属"
          );
        } else if (this.queryBtn === 4 && this.commonFlag) {
          this.updateCommonDatas.fliter.tagpc = this.tagpc;
          this.$refs.uploadFile.updateOrDelete(
            this.updateCommonDatas,
            "条约检索通用规定"
          );
        } else if (this.queryBtn === 4 && this.industryFlag) {
          this.updateIndustryDatas.fliter.tagpc = this.tagpc;
          this.$refs.uploadFile.updateOrDelete(
            this.updateIndustryDatas,
            "条约检索专属规定"
          );
        } else if (this.queryBtn === 5) {
          this.updateDatas.fliter.tagpc = this.tagpc;
          this.$refs.uploadFile.updateOrDelete(
            this.updateDatas,
            "进出口税收检索"
          );
        }
      } else {
        this.$notify({
          duration: 5000,
          color: "#fff",
          background: "#F27852",
          message: "请先登录",
        });
      }
    },
    // 点击选择上传
    chooseUpdateOrDelete() {
      if (this.userId) {
        if (this.queryBtn === 0) {
          this.$notify({
            duration: 5000,
            color: "#fff",
            background: "#F27852",
            message: "请先搜索文件后上传",
          });
        } else if (
          this.$store.state.choose.flag2 === false &&
          (this.$store.state.choose.lists.length > 0 ||
            this.$store.state.choose.commonResult.length > 0 ||
            this.$store.state.choose.industryResult.length > 0) &&
          this.$store.state.choose.result.length === 0
        ) {
          this.$refs.listCont.changeFlag();
          this.$store.commit("choose/setFlag2", true);
          this.$store.commit("choose/setChooseUp2", "确定");
          this.$notify({
            duration: 3000,
            color: "#fff",
            background: "#F27852",
            message: "请先选择要上传的文件",
          });
        } else if (
          this.$store.state.choose.flag2 === true &&
          (this.$store.state.choose.lists.length > 0 ||
            this.$store.state.choose.commonResult.length > 0 ||
            this.$store.state.choose.industryResult.length > 0) &&
          this.$store.state.choose.result.length === 0
        ) {
          this.backStatus();
          this.clearResult();
        } else {
          this.$refs.uploadFile.updateOrDelete(
            this.$store.state.choose.result,
            "选择上传"
          );
        }
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请先登录",
          duration: 5000,
        });
      }
    },
    // 选择时间
    selectTime(time) {
      this.searchPopToTop();
      this.SearchTimes = 2;
      this.isFilter = false;
      this.clickConfirmBtn = true;
      this.clickConfirmBtnC = true;
      this.clickConfirmBtnI = true;
      this.tagid = "";
      this.$refs.classification.backNum = 0;
      this.stime = time.stime;
      this.etime = time.etime;
      this.backStatus();
      this.$refs.listCont.toggle([]);
      if (this.queryBtn === 1) {
        this.currentPage = 1;
        this.getData(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 2 && this.commonFlag) {
        this.currentCommonPage = 1;
        this.getData2Common(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 2 && this.industryFlag) {
        this.currentIndustryPage = 1;
        this.getData2Industry(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 3 && this.radio === "1") {
        this.currentPage5 = 1;
        this.getDataRadio1(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 3 && this.radio === "2") {
        this.currentPage5 = 1;
        this.getDataRadio2(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 3 && this.radio === "3" && this.commonFlag) {
        this.currentCommonPage = 1;
        this.getDataRadio3CommonFiles(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (
        this.queryBtn === 3 &&
        this.radio === "3" &&
        this.industryFlag
      ) {
        this.currentIndustryPage = 1;
        this.getDataRadio3IndustryFiles(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 4 && this.commonFlag) {
        this.currentCommonPage = 1;
        this.getData4Common(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 4 && this.industryFlag) {
        this.currentIndustryPage = 1;
        this.getData4Industry(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 5) {
        this.currentPage5 = 1;
        this.getData5(this.tagid, this.stime, this.etime, this.searchText);
      }
    },
    // 搜索按钮
    searchKeyWord(keyword) {
      this.searchPopToTop();
      if (!(this.stime || this.etime || keyword)) {
        this.SearchTimes = 1;
      } else {
        this.SearchTimes = 2;
      }
      this.isFilter = false;
      this.clickConfirmBtn = true;
      this.clickConfirmBtnC = true;
      this.clickConfirmBtnI = true;
      this.tagid = "";
      this.$refs.classification.backNum = 0;
      this.searchText = keyword;
      this.backStatus();
      this.$refs.listCont.toggle([]);
      if (this.queryBtn === 1) {
        this.currentPage = 1;
        this.getData(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 2 && this.commonFlag) {
        this.currentCommonPage = 1;
        this.getData2Common(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 2 && this.industryFlag) {
        this.currentIndustryPage = 1;
        this.getData2Industry(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 3 && this.radio === "1") {
        this.currentPage5 = 1;
        this.getDataRadio1(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 3 && this.radio === "2") {
        this.currentPage5 = 1;
        this.getDataRadio2(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 3 && this.radio === "3" && this.commonFlag) {
        this.currentCommonPage = 1;
        this.getDataRadio3CommonFiles(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (
        this.queryBtn === 3 &&
        this.radio === "3" &&
        this.industryFlag
      ) {
        this.currentIndustryPage = 1;
        this.getDataRadio3IndustryFiles(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 4 && this.commonFlag) {
        this.currentCommonPage = 1;
        this.getData4Common(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 4 && this.industryFlag) {
        this.currentIndustryPage = 1;
        this.getData4Industry(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 5) {
        this.currentPage5 = 1;
        this.getData5(this.tagid, this.stime, this.etime, this.searchText);
      }
    },
    // 清除时间按钮
    clearTime() {
      if (!this.searchText) {
        this.SearchTimes = 1;
      } else {
        this.SearchTimes = 2;
      }
      this.isFilter = false;
      this.clickConfirmBtn = true;
      this.clickConfirmBtnC = true;
      this.clickConfirmBtnI = true;
      this.tagid = "";
      this.$refs.classification.backNum = 0;
      this.stime = "";
      this.etime = "";
      this.backStatus();
      this.$refs.listCont.toggle([]);
      if (this.queryBtn === 1) {
        this.currentPage = 1;
        this.getData(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 2 && this.commonFlag) {
        this.currentCommonPage = 1;
        this.getData2Common(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 2 && this.industryFlag) {
        this.currentIndustryPage = 1;
        this.getData2Industry(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 3 && this.radio === "1") {
        this.currentPage5 = 1;
        this.getDataRadio1(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 3 && this.radio === "2") {
        this.currentPage5 = 1;
        this.getDataRadio2(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 3 && this.radio === "3" && this.commonFlag) {
        this.currentCommonPage = 1;
        this.getDataRadio3CommonFiles(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (
        this.queryBtn === 3 &&
        this.radio === "3" &&
        this.industryFlag
      ) {
        this.currentIndustryPage = 1;
        this.getDataRadio3IndustryFiles(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 4 && this.commonFlag) {
        this.currentCommonPage = 1;
        this.getData4Common(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 4 && this.industryFlag) {
        this.currentIndustryPage = 1;
        this.getData4Industry(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 5) {
        this.currentPage5 = 1;
        this.getData5(this.tagid, this.stime, this.etime, this.searchText);
      }
    },
    // 改变tagid的值
    changeTagid(val) {
      this.clickFlag = false;
      let active = this.$store.state.commonSearchData.active;
      if (active === 0) {
        this.clickFlagC = false;
      } else if (active === 1) {
        this.clickFlagI = false;
      }
      this.tagid = val;
      this.backStatus();
      this.$refs.listCont.toggle([]);
    },
    // 改变页码
    changePage(num) {
      this.currentPage = num;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    changePage5(num) {
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      if (this.queryBtn === 2 && this.commonFlag) {
        this.currentCommonPage = num;
        this.getData2Common(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 2 && this.industryFlag) {
        this.currentIndustryPage = num;
        this.getData2Industry(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 3 && this.radio === "1") {
        this.currentPage5 = num;
        this.getDataRadio1(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 3 && this.radio === "2") {
        this.currentPage5 = num;
        this.getDataRadio2(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 3 && this.radio === "3" && this.commonFlag) {
        this.currentCommonPage = num;
        this.getDataRadio3CommonFiles(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (
        this.queryBtn === 3 &&
        this.radio === "3" &&
        this.industryFlag
      ) {
        this.currentIndustryPage = num;
        this.getDataRadio3IndustryFiles(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 4 && this.commonFlag) {
        this.currentCommonPage = num;
        this.getData4Common(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 4 && this.industryFlag) {
        this.currentIndustryPage = num;
        this.getData4Industry(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 5) {
        this.currentPage5 = num;
        this.getData5(this.tagid, this.stime, this.etime, this.searchText);
      }
    },
    prevPage() {
      // 上一页
      if (this.currentPage == 1) return;
      this.currentPage--;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    nextPage() {
      // 下一页
      if (this.currentPage == this.total) return;
      this.currentPage++;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    jumpToPageSize(num) {
      // 跳转到多少页
      this.currentPage = num;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    prevPage5() {
      // 上一页
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      if (this.queryBtn === 2 && this.commonFlag) {
        if (this.currentCommonPage == 1) return;
        this.currentCommonPage--;
        this.getData2Common(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 2 && this.industryFlag) {
        if (this.currentIndustryPage == 1) return;
        this.currentIndustryPage--;
        this.getData2Industry(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 3 && this.radio === "1") {
        if (this.currentPage5 == 1) return;
        this.currentPage5--;
        this.getDataRadio1(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 3 && this.radio === "2") {
        if (this.currentPage5 == 1) return;
        this.currentPage5--;
        this.getDataRadio2(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 3 && this.radio === "3" && this.commonFlag) {
        if (this.currentCommonPage == 1) return;
        this.currentCommonPage--;
        this.getDataRadio3CommonFiles(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (
        this.queryBtn === 3 &&
        this.radio === "3" &&
        this.industryFlag
      ) {
        if (this.currentIndustryPage == 1) return;
        this.currentIndustryPage--;
        this.getDataRadio3IndustryFiles(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 4 && this.commonFlag) {
        if (this.currentCommonPage == 1) return;
        this.currentCommonPage--;
        this.getData4Common(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 4 && this.industryFlag) {
        if (this.currentIndustryPage == 1) return;
        this.currentIndustryPage--;
        this.getData4Industry(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 5) {
        if (this.currentPage5 == 1) return;
        this.currentPage5--;
        this.getData5(this.tagid, this.stime, this.etime, this.searchText);
      }
    },
    nextPage5() {
      // 下一页
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      if (this.queryBtn === 2 && this.commonFlag) {
        if (this.currentCommonPage == this.commonTotal5) return;
        this.currentCommonPage++;
        this.getData2Common(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 2 && this.industryFlag) {
        if (this.currentIndustryPage == this.industryTotal5) return;
        this.currentIndustryPage++;
        this.getData2Industry(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 3 && this.radio === "1") {
        if (this.currentPage5 == this.total5) return;
        this.currentPage5++;
        this.getDataRadio1(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 3 && this.radio === "2") {
        if (this.currentPage5 == this.total5) return;
        this.currentPage5++;
        this.getDataRadio2(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 3 && this.radio === "3" && this.commonFlag) {
        if (this.currentCommonPage == this.commonTotal5) return;
        this.currentCommonPage++;
        this.getDataRadio3CommonFiles(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (
        this.queryBtn === 3 &&
        this.radio === "3" &&
        this.industryFlag
      ) {
        if (this.currentIndustryPage == this.industryTotal5) return;
        this.currentIndustryPage++;
        this.getDataRadio3IndustryFiles(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 4 && this.commonFlag) {
        if (this.currentCommonPage == this.commonTotal5) return;
        this.currentCommonPage++;
        this.getData4Common(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 4 && this.industryFlag) {
        if (this.currentIndustryPage == this.industryTotal5) return;
        this.currentIndustryPage++;
        this.getData4Industry(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 5) {
        if (this.currentPage5 == this.total5) return;
        this.currentPage5++;
        this.getData5(this.tagid, this.stime, this.etime, this.searchText);
      }
    },
    jumpToPageSize5(num) {
      // 跳转到多少页
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere2");
        dom.scrollIntoView();
      });
      if (this.queryBtn === 2 && this.commonFlag) {
        this.currentCommonPage = num;
        this.getData2Common(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 2 && this.industryFlag) {
        this.currentIndustryPage = num;
        this.getData2Industry(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 3 && this.radio === "1") {
        this.currentPage5 = num;
        this.getDataRadio1(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 3 && this.radio === "2") {
        this.currentPage5 = num;
        this.getDataRadio2(this.tagid, this.stime, this.etime, this.searchText);
      } else if (this.queryBtn === 3 && this.radio === "3" && this.commonFlag) {
        this.currentCommonPage = num;
        this.getDataRadio3CommonFiles(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (
        this.queryBtn === 3 &&
        this.radio === "3" &&
        this.industryFlag
      ) {
        this.currentIndustryPage = num;
        this.getDataRadio3IndustryFiles(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 4 && this.commonFlag) {
        this.currentCommonPage = num;
        this.getData4Common(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 4 && this.industryFlag) {
        this.currentIndustryPage = num;
        this.getData4Industry(
          this.tagid,
          this.stime,
          this.etime,
          this.searchText
        );
      } else if (this.queryBtn === 5) {
        this.currentPage5 = num;
        this.getData5(this.tagid, this.stime, this.etime, this.searchText);
      }
    },
    // 恢复选择的状态
    backStatus() {
      this.$refs.listCont.changeFlag2();
      this.$store.commit("choose/setFlag2", false);
      this.$store.commit("choose/setChooseUp2", "选择上传");
      this.$store.commit("choose/setResult", []);
    },
    clearResult() {
      this.$refs.listCont.toggle([]);
    },
    // 切换专属和通用规定
    changeCommonFlag() {
      this.SearchTimes = 1;
      this.isFilter = false;
      this.clickFlagI = true;
      this.commonFlag = true;
      this.industryFlag = false;
      this.currentCommonPage = 1;
      (this.stime = ""), // 开始时间
        (this.etime = ""), // 结束时间
        (this.searchText = ""), // 搜索关键字
        (this.tagid = "");
      this.$refs.searchBox.keyword = "";
      this.$refs.searchBox.startAndEndTimeOne = "";
      this.$refs.searchBox.startAndEndTimeTwo = "";
      this.$refs.classification.changeFixedBtn();

      // 清除数据
      this.backStatus();
      this.$refs.listCont.toggle([]);

      if (this.queryBtn === 2 && this.commonFlag) {
        this.getData2Common();
        this.$refs.classification.clearSearchValue();
      } else if (this.queryBtn === 3 && this.radio === "3" && this.commonFlag) {
        this.getDataRadio3CommonFiles();
        this.$refs.classification.clearSearchValue();
      } else if (this.queryBtn === 4 && this.commonFlag) {
        this.getData4Common();
      }
    },
    // 切换专属和通用规定
    changeIndustryFlag() {
      this.SearchTimes = 1;
      this.isFilter = false;
      this.clickFlagC = true;
      this.industryFlag = true;
      this.commonFlag = false;
      this.currentIndustryPage = 1;
      (this.stime = ""), // 开始时间
        (this.etime = ""), // 结束时间
        (this.searchText = ""), // 搜索关键字
        (this.tagid = "");
      this.$refs.searchBox.keyword = "";
      this.$refs.searchBox.startAndEndTimeOne = "";
      this.$refs.searchBox.startAndEndTimeTwo = "";
      this.$refs.classification.changeFixedBtn();

      // 清除数据
      this.backStatus();
      this.$refs.listCont.toggle([]);

      if (this.queryBtn === 2 && this.industryFlag) {
        this.getData2Industry();
        this.$refs.classification.clearSearchValue();
      } else if (
        this.queryBtn === 3 &&
        this.radio === "3" &&
        this.industryFlag
      ) {
        this.getDataRadio3IndustryFiles();
        this.$refs.classification.clearSearchValue();
      } else if (this.queryBtn === 4 && this.industryFlag) {
        this.getData4Industry();
      }
    },
    changeValue2(value) {
      this.value2 = value;
    },
    changeValue3(value) {
      this.value3 = value;
    },
    changeValue11(value) {
      this.value11 = value;
    },
    changeValue12(value) {
      this.value12 = value;
    },
    changeValue13(value) {
      this.value13 = value;
    },
    changeValue4(value) {
      // 进出口税收检索的类别切换
      this.value4 = value;
    },
    // 综合检索的查询内容改变
    changeSearch1(search1) {
      this.search1 = search1;
    },
    // 综合检索的文件效力改变
    changeValue1(value) {
      this.value1 = value;
    },
    // 行业检索的文件效力改变
    changeSearch5(value) {
      this.value5 = value;
    },
    // 税收优惠检索的文件效力改变
    changeSearch6(value) {
      this.value6 = value;
    },
    // 条约检索的文件效力改变
    changeSearch7(value) {
      this.value7 = value;
    },
    // 进出口税收检索的文件效力改变
    changeSearch8(value) {
      this.value8 = value;
    },
    // 获取下拉查询条件的数据
    getSelectData() {
      let reqGetIndustryArr = this.$store.state.commonSearchData.reqGetIndustry; // 行业
      // let reqGetTaxesArr = this.$store.state.commonSearchData.reqGetTaxes // 税种
      let reqGetInOutArr = this.$store.state.commonSearchData.reqGetInOut; // 进出口
      let reqGetReductionArr = this.$store.state.commonSearchData
        .reqGetReduction; // 优惠项目
      let reqGetReduction_taxArr = this.$store.state.commonSearchData
        .reqGetReduction_tax; // 优惠税种
      let reqGetReduction_industryArr = this.$store.state.commonSearchData
        .reqGetReduction_industry; // 优惠行业
      let reqGetCountryArr = this.$store.state.commonSearchData.reqGetCountry; // 获取国家
      // console.log('// 税种reqGetTaxesArr', reqGetTaxesArr)
      reqGetIndustryArr.forEach((item) => {
        this.option2.push({ text: item.label, value: item.id });
      });
      reqGetInOutArr.forEach((item) => {
        this.option4.push({ text: item.label, value: item.id });
      });
      reqGetReductionArr.forEach((item) => {
        this.option11.push({ text: item.label, value: item.id });
      });
      reqGetReduction_taxArr.forEach((item) => {
        this.option12.push({ text: item.label, value: item.id });
      });
      reqGetReduction_industryArr.forEach((item) => {
        this.option13.push({ text: item.label, value: item.id });
      });
      reqGetCountryArr.forEach((item) => {
        this.option3.push({ text: item.label, value: item.id });
      });
    },
    // 改变radio时
    changeRadio(name) {
      this.value11 = "0";
      this.value12 = "0";
      this.value13 = "0";
      this.value6 = "1";
      if (name === "1") {
        this.radio = "1";
        this.disabled1 = true;
        this.disabled2 = false;
        this.disabled3 = true;
      } else if (name === "2") {
        this.radio = "2";

        this.disabled1 = false;
        this.disabled2 = true;
        this.disabled3 = true;
      } else if (name === "3") {
        this.radio = "3";

        this.disabled1 = true;
        this.disabled2 = true;
        this.disabled3 = false;
      }
    },
    // 初始化数据
    startClear() {
      this.flag = false;
      this.lists = [];
      this.lists4 = [];
      this.commonLists = []; // 通用规定
      this.industryLists = []; // 专属规定
      this.currentPage = 1;
      this.currentPage5 = 1;
      this.currentCommonPage = 1;
      this.currentIndustryPage = 1;
      this.stime = ""; // 开始时间
      this.etime = ""; // 结束时间
      this.searchText = ""; // 搜索关键字
      this.tagid = "";
      this.tagpc = [];
      this.t1 = [];
      this.t2 = [];
      this.t3 = [];
      this.data = {};
      this.dataC = {};
      this.dataI = {};
    },
    // 滚动搜索引擎到顶部
    searchPopToTop() {
      this.$refs.searchEnginePop.$el.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
      this.$refs.searchEnginePop.activeNames1 = [];
    },
  },
  destroyed() {
    this.$store.commit("choose/setFlag2", false);
    this.$store.commit("choose/setChooseUp2", "选择上传");
    this.$store.dispatch("choose/updateLists", []);
    this.$store.commit("choose/setResult", []);
    this.$store.commit("commonSearchData/changeActive", 0);
  },
};
</script>

<style lang="less" scoped>
#searchEngineD {
  display: flex;
  flex-direction: column;
  .top {
    flex: 1;
    margin-bottom: 70px;
  }
  .selectNavS {
    padding: 20px 20px 150px;
  }
  .timeBox {
    height: 45px;
    display: flex;
    margin: 0 0 2px 0;
    padding: 0 8px 0 15px;
    .time {
      flex: 1;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 8px;
    }
  }
  .searchItem {
    display: flex;
    .name {
      line-height: 52px;
      flex: 0 0 70px;
      text-align: center;
      color: #333;
    }
    .content {
      flex: 1;
    }
  }
  .btn {
    text-align: center;
    margin-top: 20px;
  }
  .van-cell {
    height: 50px;
    line-height: 50px;
  }
}
</style>
